<template>
    <div class="loader-dots">
        <div class="loader-dots-dot"></div>
        <div class="loader-dots-dot"></div>
        <div class="loader-dots-dot"></div>
        <div class="loader-dots-dot"></div>
        <div class="loader-dots-dot"></div>
    </div>
</template>

<script>
export default {
  name: 'LoaderDots'
}
</script>

<style lang="scss">
@import "./src/sass/components/loader-dots"
</style>



// WEBPACK FOOTER //
// LoaderDots.vue?417b7aeb